export default __webpack_public_path__ + "static/media/team-1.562936ef.png";